<template>
	<v-container class="fill-height">
		<div class="flex-centerize width-100 height-100">
			<Row v-if="isError"><AppIcon name="info" class="mr-2"></AppIcon>{{ errorMessage }}</Row>
			<span v-else>SSO - Logging in, hold on please.</span>
		</div>
	</v-container>
</template>

<script>
/* eslint-disable no-undef */
import { mapGetters, mapActions } from 'vuex';

import ErrorHandlingService, { STATUS_CODES } from '@/utils/error-handling-service';

export default {
	name: 'GoogleCallback',
	props: {
		code: {
			type: String,
			required: false,
		},
	},
	computed: {
		...mapGetters('main', ['appURL']),
		chromeExtensionID() {
			return process.env.VUE_APP_CHROME_EXTENSION_ID;
		},
	},
	data() {
		return {
			isError: false,
			errorMessage: '',
		};
	},
	methods: {
		...mapActions(['loginWithSSOCode']),
	},
	async mounted() {
		try {
			await this.loginWithSSOCode({ code: this.code });
		} catch (err) {
			console.error(err);
			if (ErrorHandlingService.extractStatusCode(err) === STATUS_CODES.FORBIDDEN) {
				this.isError = true;
				this.errorMessage = ErrorHandlingService.extractErrorMessage(err);
			} else {
				this.$toast.error(err, { timeout: 3000 });
			}
		}
	},
};
</script>

<style scoped></style>
